export const CLOSING_REASONS_UI = 'CLOSING_REASONS_UI';
